<template>
  <div>
    <h6 class="mb-3">{{ this.label }}</h6>
    <ResponseList
      v-if="isDropdown"
      :question-set="listData"
      :total-count="totalCount"
    />
    <PieChart
      v-else
      :chart-data="chartData"
      @rowClick="handleClick"
      @chartClick="handleClick"
    />
  </div>
</template>

<script>
  import _ from 'lodash';
  import { INSPECTION_ITEM_RESPONSE } from '@/_legacy/constants';
  import PieChart from '@/_legacy/views/Analytics/components/PieChart.vue';
  import ResponseList from './ResponseList';
  import { pushRoute } from '@/ui/helpers/uiHelper';

  export default {
    name: 'List',

    components: {
      PieChart,
      ResponseList,
    },

    props: {
      questionSet: {
        type: Object,
        default: () => {
        },
      },
      label: {
        type: String,
        default: '',
      },
      responseSet: {
        type: Object,
        default: () => {
        },
      },
      uuid: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        colors: [
          'blue',
          'orange',
          'purple',
          'green',
          'red',
          'light-blue',
          'pink',
          'yellow',
        ],
      };
    },

    computed: {
      questions() {
        return _.filter(this.questionSet.questions, 'response');
      },
      chartData() {
        return {
          series: _.map(this.responseSet.responses, (response, key) => ({
            className: this.colors[key],
            label: response.title,
            meta: {
              response: response.title,
              uuid: this.uuid,
              type: INSPECTION_ITEM_RESPONSE.LIST,
            },
            value: _.sumBy(
              _.filter(
                this.questions,
                question => _.find(question.response_json ? JSON.parse(question.response_json) : null, ['title', response.title]),
              ),
              'count',
            ),
          })),
        };
      },
      listData() {
        return _.filter(
          this.questionSet.questions,
          question => question.response !== null,
        );
      },
      totalCount() {
        return _.sumBy(this.listData, 'count');
      },
      isDropdown() {
        return this.responseSet.type === 'dropdown';
      },
    },

    methods: {
      handleClick(meta) {
        pushRoute({
          name: 'analyticsSummaryChecklistsExplain',
          params: { id: this.$route.params.id },
          query: {
            ...meta.uuid !== undefined && { uuid: meta.uuid },
            ...meta.response !== undefined && { response: meta.response },
            ...meta.type !== undefined && { type: meta.type },
          },
        });
      },
    },
  };
</script>
